import React, { useState, useEffect } from "react";
import { Task } from "./TaskManagement";
import "./TaskManagement.scss";

interface TaskDetailSidebarFormProps {
  task?: Task;
  onClose: () => void;
  onSave: (task: Task) => void;
}

// Dummy-Daten für die Liste der Mitarbeiter
const employees = [
  { id: "1", name: "Peter Meier" },
  { id: "2", name: "Petra Schmidt" },
  { id: "3", name: "Peter Schneider" },
  { id: "4", name: "Hans Schmidt" },
  { id: "5", name: "Maria Müller" },
];

const TaskDetailSidebarForm: React.FC<TaskDetailSidebarFormProps> = ({
  task,
  onClose,
  onSave,
}) => {
  const [title, setTitle] = useState<string>(task ? task.title : "");
  const [status, setStatus] = useState<"todo" | "inProgress" | "done" | "lost">(
    task ? task.status : "todo"
  );
  const [priority, setPriority] = useState<"low" | "medium" | "high">(
    task ? task.priority : "medium"
  );
  const [dueDate, setDueDate] = useState<string>(task?.dueDate || "");
  const [description, setDescription] = useState<string>(
    task?.description || ""
  );
  const [responsibleEmployee, setResponsibleEmployee] = useState<string>(
    (task && (task as any).responsibleEmployee) || ""
  );

  useEffect(() => {
    if (task) {
      setTitle(task.title);
      setStatus(task.status);
      setPriority(task.priority);
      setDueDate(task.dueDate || "");
      setDescription(task.description || "");
      setResponsibleEmployee((task as any).responsibleEmployee || "");
    }
  }, [task]);

  const handleSave = () => {
    if (title.trim() === "") {
      alert("Der Titel darf nicht leer sein!");
      return;
    }

    const newTask: Task & { responsibleEmployee?: string } = {
      id: task?.id || "",
      title,
      status,
      priority,
      dueDate,
      description,
      category: "Kurzzeitpflege", // ggf. anpassen oder als zusätzlichen State verwalten
      responsibleEmployee,
    };

    onSave(newTask);
  };

  return (
    <div className="detail-sidebar-right">
      <div className="sidebar-header">
        <h2>{task ? "Aufgabe bearbeiten" : "Neue Aufgabe erstellen"}</h2>
        <i className="fa-solid fa-close" onClick={onClose}></i>
      </div>
      <div className="sidebar-content">
        <div className="input-group">
          <label>Titel</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Aufgabentitel eingeben"
          />
        </div>
        <div className="input-group">
          <label>Status</label>
          <select
            value={status}
            onChange={(e) =>
              setStatus(e.target.value as "todo" | "inProgress" | "done" | "lost")
            }
          >
            <option value="todo">To Do</option>
            <option value="inProgress">In Progress</option>
            <option value="done">Erledigt</option>
            <option value="lost">Verloren</option>
          </select>
        </div>
        <div className="input-group">
          <label>Priorität</label>
          <select
            value={priority}
            onChange={(e) =>
              setPriority(e.target.value as "low" | "medium" | "high")
            }
          >
            <option value="low">Niedrig</option>
            <option value="medium">Mittel</option>
            <option value="high">Hoch</option>
          </select>
        </div>
        <div className="input-group">
          <label>Fälligkeitsdatum</label>
          <input
            type="date"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
          />
        </div>
        <div className="input-group">
          <label>Beschreibung</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Beschreibung der Aufgabe..."
          />
        </div>
        <div className="input-group">
          <label>Zuständiger Mitarbeiter</label>
          <select
            value={responsibleEmployee}
            onChange={(e) => setResponsibleEmployee(e.target.value)}
          >
            <option value="">Bitte wählen</option>
            {employees.map((employee) => (
              <option key={employee.id} value={employee.name}>
                {employee.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="sidebar-actions">
        <button onClick={handleSave}>Speichern</button>
        <button onClick={onClose} className="cancel-button">
          Abbrechen
        </button>
      </div>
    </div>
  );
};

export default TaskDetailSidebarForm;
